import Axios from "helpers/Interceptor"
import * as Sentry from "@sentry/browser"

export type ApiKeyResponse = {
    key: string
    userId: string
    user?: {
        id: string
        email: string
        name: string
    },
    status: 'success' | 'error'
}

export const createApiKey_api = async ({
    userId,
    brandId
}: {
    userId: number
    brandId?: number
}): Promise<ApiKeyResponse | null> => {
    try {
        const response = await Axios.post('/v2/api-key', {
            userId,
            brandId
        })
        return response.data
    } catch (error) {
        Sentry.captureException(error)
        return null
    }
}

export const getApiKeys_api = async ({
    userId
}: {
    userId: number
}): Promise<ApiKeyResponse[] | null> => {
    try {
        const response = await Axios.get(`/v2/api-key/${userId}`)
        return response.data
    } catch (error) {
        Sentry.captureException(error)
        return null
    }
}

export const deleteApiKey_api = async ({
    key
}: {
    key: string
}): Promise<ApiKeyResponse | null> => {
    try {
        const response = await Axios.delete(`/v2/api-key/${key}`)
        return response.data
    } catch (error) {
        Sentry.captureException(error)
        return null
    }
}